import { Card, Typography } from "@mui/material";
import SoftBox from "../../../../../../../../../../components/SoftBox";
import { getStoreCurrencySymbol } from "../../../../../../../../../../utils/currency";
import "./index.css";

export const OfferItem = ({ offer }) => {
  if (!offer) return null;

  const { offerType, mainOfferItemList, offerDetailsEntityList } = offer;

  let offerText = null;

  switch (offerType) {
    case "BUY_X_GET_Y":
      offerText = `Buy ${mainOfferItemList[0]?.buyQuantity} ${mainOfferItemList[0]?.mainItemName} Get ${offerDetailsEntityList[0]?.getQuantity} ${offerDetailsEntityList[0]?.itemName} Free!`;
      break;
    case "BUY_X_GET_DISCOUNT":
      offerText = `Buy ${mainOfferItemList[0]?.buyQuantity} ${mainOfferItemList[0]?.mainItemName} Get ${offerDetailsEntityList[0]?.offerDiscount} ${offerDetailsEntityList[0]?.discountType} Off`;
      break;
    case "STEP_PROMOTIONS":
      offerText = `Buy ${mainOfferItemList[0]?.buyQuantity} ${mainOfferItemList[0]?.mainItemName} Get ${offerDetailsEntityList[0]?.getQuantity} ${offerDetailsEntityList[0]?.itemName} at ${offerDetailsEntityList[0]?.offerDiscount} ${offerDetailsEntityList[0]?.discountType} Off`;
      break;
    case "OFFER_ON_MRP":
      offerText = `Buy ${mainOfferItemList[0]?.buyQuantity} ${mainOfferItemList[0]?.mainItemName} Get ${offerDetailsEntityList[0]?.offerDiscount} ${offerDetailsEntityList[0]?.discountType} on MRP`;
      break;
    case "BUY_X_GET_DISCOUNT_ON_Y":
      offerText = `Buy ${mainOfferItemList[0]?.buyQuantity} ${mainOfferItemList[0]?.mainItemName} And Get ${offerDetailsEntityList[0]?.getQuantity} ${offerDetailsEntityList[0]?.itemName} at ${offerDetailsEntityList[0]?.offerDiscount} ${offerDetailsEntityList[0]?.discountType} Off`;
      break;
    case "COMBO_OFFER_DISCOUNT":
      offerText = constructOfferText(mainOfferItemList, offerDetailsEntityList);
    default:
      break;
  }

  return offerText ? <li>{offerText}</li> : null;
};

function constructOfferText(mainOfferItemList, offerDetailsEntityList) {
  let offerText = "Buy ";
  mainOfferItemList?.forEach((item, index) => {
    offerText += `${item?.buyQuantity} ${item?.mainItemName}`;
    if (index < mainOfferItemList?.length - 1) {
      offerText += " and ";
    }
  });
  offerText += ` Get ${offerDetailsEntityList[0]?.offerDiscount} ${offerDetailsEntityList[0]?.discountType} Off`;
  return offerText;
}

export const AvailableOffers = ({ offerListData }) => {
  return (
    <SoftBox>
      {offerListData.map((ele, index) => (
        <Card className="offerlist-container" key={index}>
          <Typography variant="h4" sx={{ fontSize: "1rem" }}>
            Product : {ele?.productName}({ele?.productGtin})
          </Typography>
          <Typography variant="h4" sx={{ fontSize: "1rem" }}>
            Batch No : {ele?.productBatchNo}
          </Typography>
          <Typography variant="h4" sx={{ fontSize: "1rem" }}>
            Mrp : {getStoreCurrencySymbol()}{ele?.productMrp} | SP : {getStoreCurrencySymbol()}{ele?.productSp}
          </Typography>
          <ul>
            <p className="available-offer-text">Available Offer</p>
            {ele?.availableOfferList.map((offer, index) => (
              <OfferItem offer={offer} key={index} />
            ))}
          </ul>
        </Card>
      ))}
    </SoftBox>
  );
};
